export const colorPaletteValidNames = ["palette1", "palette2", "palette3"];
//# sourceMappingURL=palettes.js.map